// extracted by mini-css-extract-plugin
module.exports = {"empty":"index_empty__PcnR3","empty__img":"index_empty__img__LlLJ8"};